<template>
    <li>
        <a :href="doc.url" target="_blank">{{ doc.title }}</a>
        <span v-if="auth" class="btn btn-sm btn-outline-danger" @click="remove"> delete</span>
    </li>
</template>

<script>
import axios from 'axios'

export default {
    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },
    props: {
        doc: Object
    },
    methods: {
        async remove() {
            const id = this.doc._id;
            await axios.delete(`/api/document/${id}`);
            window.location.reload();
        }
    }
}
</script>

<style></style>